export default __webpack_public_path__ + "static/media/completeSignup_korean.a95103c0.png";